import { isEnabled } from '@utils/feature';
import { render } from 'base/wrapped-render';
import { PoMicroFrontend } from 'micro-frontend.react';
import { useEffect } from 'react';

export type GlobalEmploymentInPageMessageProps = {
	margin?: number | string;
};

/**
 * GlobalEmploymentInPageMessage
 * @description This component is used to Marketing messages in Hiring and Employee pages. This will need to be moved to PO at some point in the future
 */
export const GlobalEmploymentInPageMessage = ({margin}:GlobalEmploymentInPageMessageProps) => {
	useEffect(() => {
		const rootEl = document.createElement('div');
		if (document.getElementById('js-globalEmploymentInPageMessaging')) {
			document
				.getElementById('js-globalEmploymentInPageMessaging')
				.appendChild(rootEl);
			render(
				<PoMicroFrontend
					route="/global-employment/in-page-messaging"
					margin={margin}
				/>,
				rootEl,
			);
		}
		return () => {
			document.body.removeChild(rootEl);
		};
	}, []);

	if (isEnabled('EOR_REMOTE_ONBOARDING_INTEGRATION')) {
		return <div id="js-globalEmploymentInPageMessaging"></div>;
	}

	return null;
};
